export default "__VITE_ASSET__DhyIyYef__"